import styled from 'styled-components';
import css from '@styled-system/css';

export const ProductCard = styled.div`
  ${css({
    color: 'cardText',
    backgroundColor: 'cardBackground',
  })}
 // margin-top: 30px;
  display: inline-block;
  position: relative;
  //width: 100%;

  //max-width: 680px;
  width: 380px;
  margin-bottom: 2em;
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  
  a {
    color: ${props => props.theme.colors.cardText};
  }
`

export const CardImageWrapper = styled.div`
  //height: 60%;
  height: 250px;
  position: relative;
  overflow: hidden;
  margin-left: 1em;
  margin-right: 1em;
  margin-top: -2em;
  border-radius: 6px;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
`

export const ProductTitle = styled.div`
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const ProductDescription = styled.p`
`

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  pointer-events: none;
  vertical-align: middle;
`

export const ProductCardContent = styled.div`
  ${css({
    paddingTop: [3],
    paddingBottom: [3],
    paddingRight: [4],
    paddingLeft: [4],
  })}
  `